import React, { useEffect, useState } from 'react';
import { Box, TextField, IconButton, Typography, InputAdornment } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';

const VV = { primary: '#3F2B96', secondary: '#7F5AF0', accent: '#00C896', border: 'rgba(63,43,150,0.10)' };

const OField = ({ icon, color, ...props }) => (
  <TextField variant="outlined" fullWidth size="small"
    InputProps={{ startAdornment: <InputAdornment position="start">{React.cloneElement(icon, { sx: { color: color || VV.secondary, fontSize: 16 } })}</InputAdornment> }}
    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', bgcolor: '#fafafa', '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: color || VV.secondary }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: color || VV.secondary, borderWidth: 2 } } }}
    {...props}
  />
);

const Office = ({ office, officeLocations, setOfficeLocations, index, removeOfficeLoc }) => {
  const [contact, setContact] = useState(office.contact || '');
  const [address, setAddress] = useState(office.address || '');
  const [email_id, setEmailId] = useState(office.email_id || '');

  useEffect(() => { setContact(office.contact || ''); setAddress(office.address || ''); setEmailId(office.email_id || ''); }, [office]);

  const update = (field, value) => {
    const updated = [...officeLocations];
    updated[index] = { ...updated[index], [field]: value };
    setOfficeLocations(updated);
  };

  return (
    <Box sx={{ borderRadius: '14px', border: `1.5px solid ${VV.border}`, bgcolor: '#fff', boxShadow: '0 4px 12px rgba(63,43,150,0.06)', p: 2.5, position: 'relative', transition: 'box-shadow 0.2s', '&:hover': { boxShadow: '0 8px 24px rgba(63,43,150,0.12)' } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 28, height: 28, borderRadius: '8px', background: `linear-gradient(135deg, ${VV.primary}, ${VV.secondary})`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <BusinessIcon sx={{ fontSize: 14, color: '#fff' }} />
          </Box>
          <Typography variant="body2" sx={{ fontWeight: 700, color: VV.primary }}>Office {index + 1}</Typography>
        </Box>
        <IconButton size="small" onClick={() => removeOfficeLoc(office)}
          sx={{ color: '#ef5350', bgcolor: '#ffebee', borderRadius: '8px', width: 28, height: 28, '&:hover': { bgcolor: '#ffcdd2', transform: 'scale(1.1)' }, transition: 'all 0.2s' }}>
          <HighlightOffIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <OField label="Phone / Contact" icon={<PhoneIcon />} color="#00897B" value={contact}
          onChange={e => { setContact(e.target.value); update('contact', e.target.value); }} />
        <OField label="Address" icon={<LocationOnIcon />} color="#1565C0" value={address}
          onChange={e => { setAddress(e.target.value); update('address', e.target.value); }} />
        <OField label="Email" icon={<EmailIcon />} color="#7B1FA2" value={email_id}
          onChange={e => { setEmailId(e.target.value); update('email_id', e.target.value); }} />
      </Box>
    </Box>
  );
};

export default Office;
